import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ConfigProvider } from 'antd';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import MainLayout from './components/Layout/MainLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import FeatureRequests from './pages/FeatureRequests';
import Users from './pages/Users';
import WhatsNews from './pages/WhatsNews';
import Partners from './pages/Partners';
import Hints from './pages/Hints';
import 'antd/dist/reset.css';
import './App.css';
import Faqs from './pages/Faqs';
import TapitaCredits from './pages/TapitaCredits';
import ZohoAccounts from './pages/ZohoAccounts';
import AppAnalytics from './pages/AppAnalytics';
import Uploads from './pages/Uploads';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const theme = {
  token: {
    colorPrimary: '#1890ff',
    borderRadius: 6,
  },
};

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider theme={theme}>
        <AuthProvider>
          <Router>
            <div className="App">
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <MainLayout />
                    </ProtectedRoute>
                  }
                >
                  <Route index element={<Navigate to="/dashboard" replace />} />
                  <Route path="dashboard" element={<Dashboard />} />
                  <Route path="feature-requests" element={<FeatureRequests />} />
                  <Route path="users" element={<Users />} />
                  <Route path="whats-news" element={<WhatsNews />} />
                  <Route path="partners" element={<Partners />} />
                  <Route path="hints" element={<Hints />} />
                  <Route path="faqs" element={<Faqs />} />
                  <Route path="tapita-credits" element={<TapitaCredits />} />
                  <Route path="zoho-accounts" element={<ZohoAccounts />} />
                  <Route path="uploads" element={<Uploads />} />
                  <Route path="app-analytics/:appId" element={<AppAnalytics />} />
                </Route>
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </div>
          </Router>
        </AuthProvider>
      </ConfigProvider>
    </QueryClientProvider>
  );
}

export default App;

